// export const handleApiError = (error) => {
//     console.error("AXIOS ERROR FULL OBJECT 👉", error);
//     if (error.response) {
//         // The request was made and the server responded with a status code
//         // return error.response.data.message;
//         return error.response.data?.message || error.response.data || "An error occurred";
//     } else if (error.request) {
//         // The request was made but no response was received
//         return "Network error. Please try again later.";
//     } else {
//         // Something happened in setting up the request that triggered an Error
//         return error.message || "Oops, something went wrong. Please try again";
//     }
// };

export const handleApiError = (error) => {
    console.error("AXIOS ERROR FULL OBJECT 👉", error);
    if (error.response) {
        // The request was made and the server responded with a status code
        const data = error.response.data;
        if (typeof data === 'string') return data;
        return data?.message || JSON.stringify(data) || "An error occurred";
    } else if (error.request) {
        // The request was made but no response was received
        return "Network error. Please try again later.";
    } else {
        // Something happened in setting up the request that triggered an Error
        return error.message || "Oops, something went wrong. Please try again";
    }
};
